import React from 'react'
import Tab from '@mui/material/Tab'
import { useIntl } from 'react-intl'
import Tabs from '@mui/material/Tabs'
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material/styles'
import CardContent from '@mui/material/CardContent'
import SwipeableViews from 'react-swipeable-views'

import TabPanel from '../../../components/TabPanel'
import { a11yProps } from '../../../services/helper'
import LoanUsersTable from '../../../components/loanAppDetails/loan-users-table/LoanUsersTable'
import LoanInvitesTable from '../../../components/loanAppDetails/LoanInvitesTable'
import LoanContactsTable from '../../../components/loanAppDetails/LoanContactsTable'

type TabRoute = {
	key: string
	title: string
	index: number
}

enum TabsIndex {
	users = 0,
	invites = 1,
}

type PeopleContentProps = {
	className?: string
}

const PeopleContent = ({ className = '' }: PeopleContentProps) => {
	const themeMUI = useTheme()
	const { formatMessage } = useIntl()

	const tabs: TabRoute[] = [
		{
			key: 'loanUsers',
			title: formatMessage({ id: 'loans.loan_users' }),
			index: TabsIndex.users,
		},
		{
			key: 'loanInvites',
			title: formatMessage({ id: 'invites.pending_invites' }),
			index: TabsIndex.invites,
		},
	]
	const [activeTab, setActiveTab] = React.useState(
		tabs?.length > 0 ? tabs[0].index : 0
	)

	const handleTabChange = (
		_event: React.SyntheticEvent<Element, Event>,
		value: number
	) => {
		setActiveTab(value)
	}

	const handleChangeIndex = (index: number) => {
		setActiveTab(index)
	}

	return (
		<div className={className}>
			<Tabs
				variant="scrollable"
				scrollButtons="auto"
				value={activeTab}
				onChange={handleTabChange}
				aria-label="Tabs"
			>
				{tabs.map((route) => (
					<Tab
						value={route.index}
						label={route.title}
						key={route.key}
						{...a11yProps(route.index)}
					/>
				))}
			</Tabs>
			{/*	@ts-ignore */}
			<SwipeableViews
				axis={themeMUI.direction === 'rtl' ? 'x-reverse' : 'x'}
				index={activeTab}
				onChangeIndex={handleChangeIndex}
			>
				<TabPanel
					value={activeTab}
					index={TabsIndex.users}
					dir={themeMUI.direction}
				>
					<Card className="min-h-screen overflow-auto">
						<CardContent>
							<LoanUsersTable title={tabs[TabsIndex.users].title} />
							<LoanContactsTable
								title={formatMessage({ id: 'loans.loan_contacts' })}
							/>
						</CardContent>
					</Card>
				</TabPanel>
				<TabPanel
					value={activeTab}
					index={TabsIndex.invites}
					dir={themeMUI.direction}
				>
					<Card className="min-h-screen overflow-auto">
						<CardContent>
							<LoanInvitesTable
								title={tabs[TabsIndex.invites].title}
							/>
						</CardContent>
					</Card>
				</TabPanel>
			</SwipeableViews>
		</div>
	)
}

export default PeopleContent
